import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'tamanho'
}) export class TamanhoFicheiroPipe implements PipeTransform {
    public transform(valor: any): any {
        return  Math.round(valor / (1024 ** 2) * Math.pow(10, 2)) / Math.pow(10, 2);
    }
}
